import { Flex, Loader, Title } from '@mantine/core';
import { useGetSubmissionByClaimID } from 'api/resource';
import { SubmissionTimeline } from './SubmissionTimeline';

interface ClaimSubmissionsProps {
  claimID: string;
}

export const ClaimSubmissions = ({ claimID }: ClaimSubmissionsProps) => {
  const {
    data: submission = [],
    isLoading: loadingSubmission,
    isError: submissionError,
    error: submissionErrorMessage,
  } = useGetSubmissionByClaimID({
    claimID,
  });

  return (
    <Flex direction="column" align="center" justify="center">
      {loadingSubmission ? (
        <Loader />
      ) : submission?.length ? (
        <>
          <Title order={2} mb="md">
            Submissions
          </Title>
          <SubmissionTimeline
            data={submission}
            isLoading={loadingSubmission}
            isError={submissionError}
            errorMessage={submissionErrorMessage?.message}
          />
        </>
      ) : (
        <Title order={3}>No Submissions Found</Title>
      )}
    </Flex>
  );
};
